<app-music-festival-single *ngIf="festivals" [festival]="festivals[index]"
                           (nextFest)="nextFest()" (prevFest)="prevFest()"></app-music-festival-single>
